import React, { useState } from 'react';
import './Contracts.scss';
import MercurXContractTable from '../../components/MercurXContractTable/MercurXContractTable';
import { Col, Form, Row } from 'react-bootstrap';

function Contracts() {
  const [filterInput, setFilterInput] = useState('');

  return (
    <>
      <div className="text-fs-head-md mb-4">Contracts</div>
      <Row className="text-fs-body-md mt-4 text-center">
        <Col>
          <Form.Control
            className="text-fs-body-sm"
            type="text"
            placeholder="Search by abi name..."
            aria-label="text"
            aria-describedby="basic-addon1"
            value={filterInput}
            onChange={(e) => setFilterInput(e.target.value)}
            size={'sm'}
          />
        </Col>
      </Row>
      <Row
        id="projects-container"
        className="d-flex align-items-center justify-content-between mt-4"
      />
      <div id="projects-container">
        <MercurXContractTable filterInput={filterInput} />
      </div>
    </>
  );
}

export default Contracts;
